import { Injectable } from "@angular/core";
import { LoggerProvider, LoggerEvent } from '../logger/logger';
import { InAppMessage } from "../../model/api/iterables/iterables-inapp-response.entity.interface";
import { UtilsProvider } from "../../providers/myria/utils-provider";
import { APP_CONFIG } from '../../environment';
import { RouteProvider } from "../../providers/route/route";
import { SegmentProvider } from "../../providers/analytics/segment";
import { AnalyticsEventType } from "../../model/types/analytics.const";

@Injectable()
export class HomeScreenProvider {
    
    homescreenLocation: any;
    paymentAgent: any;
    cachedMenuTitle: string = null;

    constructor(
        private utilProvider: UtilsProvider,
        private routeProvider: RouteProvider,
        private analytics: SegmentProvider,
    ) {
        
    }

  setHomeScreenLocation(location: string) {
    this.homescreenLocation = location;
  }

  getCatchedMenuTitle() {
    return this.cachedMenuTitle;
  }

  setCachedMenuTitle(menuTitle: string) {
    this.cachedMenuTitle = menuTitle;
  }

  async trackHomeScreenOrActivityAccessedEvent(location: string, isCarouselShown: boolean) {
    const currentPage: any = await this.routeProvider.getLastActivePageAsync();
    if (currentPage === this.routeProvider.pages.TabsHomeActivityPage.page || currentPage === this.routeProvider.pages.ActivityPage.page) {
      if (!this.homescreenLocation)
        this.homescreenLocation = location;
      const paymentAgent = this.paymentAgent;
      const analyticsData = {
        carouselDisplayed: isCarouselShown,
        localDay: this.utilProvider.getLocalDayAsString(),
        localTime: this.utilProvider.getLocalHour(),
        location: this.homescreenLocation,
        registrationFlowType: this.utilProvider.getRegistrationFlowType(),
        ...(paymentAgent != null && { paymentAgent }),
      };

      if (APP_CONFIG.region.showNewHomePage) {
        this.analytics.trackEvent({
          eventName: AnalyticsEventType.HomeScreenAccessed,
          analyticsData: analyticsData
        }, true);
      } else {
        this.analytics.trackEvent({
          eventName: AnalyticsEventType.ActivityScreenAccessed,
          analyticsData: {
            location: this.homescreenLocation,
            ...(paymentAgent != null && { paymentAgent }),
          }
        }, true);
      }

      this.homescreenLocation = null;
      this.paymentAgent = null;
    }
  }
}


// WEBPACK FOOTER //
// ./src/providers/homescreen/homescreen.ts